module.exports = __webpack_public_path__ + "static/media/nsdl.749258ad.png";